import { Outlet, Navigate } from "react-router-dom";
import { useActor } from "@xstate/react";
import { Header } from "../modules/Header/Header";
import { Footer } from "../modules/Footer/Footer";
import { AuthState } from "../xstate/auth.machine";
import { Loader } from "../modules/Loader/Loader";
import { PromptAccess } from "../modules/PromptAccess/PromptAccess";
import { useEffect, useState } from "react";

export function Account() {
	const [stateAuth, sendAuth] = useActor(AuthState);
	const [showLoader, setShowLoader] = useState(true);

	const handleAccept = () => {
		sendAuth({ type: "allowPersonalData" });
	};

	useEffect(() => {
		if (
			!stateAuth.matches("idle") &&
			!stateAuth.matches("loading") &&
			stateAuth.context?.is_personal_data_storage_allowed !== undefined
		) {
			const timer = setTimeout(() => {
				setShowLoader(false);
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [stateAuth]);

	if (
		stateAuth.context.type === "seller" &&
		stateAuth.context.registration_document_type_status === "not_selected" &&
		stateAuth.context.service_order_verification_status === "enabled" &&
		!localStorage.getItem("redirectSeller")
	) {
		localStorage.setItem("redirectSeller", 1);
		window.location.href = "/account/type_upload";
	} else if (
		stateAuth.context.type === "seller" &&
		stateAuth.context.registration_document_type_status === "receipt" &&
		!localStorage.getItem("redirectSeller")
	) {
		localStorage.setItem("redirectSeller", 1);
		window.location.href = "/account/upload";
	} else if (
		stateAuth.context.type === "seller" &&
		stateAuth.context.registration_document_type_status === "service_order" &&
		!localStorage.getItem("redirectSeller")
	) {
		localStorage.setItem("redirectSeller", 1);
		window.location.href = "/account/order-upload";
	}

	return (
		<>
			{showLoader && (
				<div className="fullPageLoader">
					<Loader />
				</div>
			)}
			{!stateAuth.context?.is_personal_data_storage_allowed &&
			stateAuth.matches("auth") ? (
				<>
					<PromptAccess
						fnAccept={() => handleAccept()}
						fnClose={() => sendAuth({ type: "logout" })}
					/>
				</>
			) : (
				<>
					{stateAuth.matches("unAuth") && <Navigate replace to="/auth" />}
					<Header account />
					<Outlet />
					<Footer account />
				</>
			)}
		</>
	);
}
